import initialState from '../store/initialstate';
import C from '../constants/home';

export default (state = initialState().home, action = null) => {
    switch(action.type){
        case C.GET_WIDGET_LIST: {
            return state.set(C.WIDGET_LIST, action.payload);
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/home.js